module.exports = __webpack_public_path__ + "img/echo-viewpoint--icon--gray.85e81b52.svg";